import styled, { css } from 'styled-components';
import { transparentize } from 'polished';
import { COLOR_DEFAULT } from '../../constants';
import { mapper, sizeMapper, colorMapper } from '../../styles';

const getMessageBackgroundColor = props =>
  props.color === COLOR_DEFAULT || props.color === undefined ? 'transparent' : transparentize(0.9, colorMapper(props));

const Message = styled.div`
  padding: ${props => sizeMapper(props.padding, 'no')};
  background-color: ${getMessageBackgroundColor};
  line-height: 22px;
  font-size: 16px;
  color: ${colorMapper};

  ${props =>
    props.align &&
    css`
      text-align: ${props => mapper(props.align, { left: 'left', center: 'center', right: 'right' }, 'left')};
    `};
`;

export default Message;
